import {
  VERIFY_MOBILE_INVALID_REQUEST,
  VERIFY_MOBILE_FAILED,
  VERIFY_MOBILE_SUCCESS,
  VERIFY_MOBILE_NOT_FOUND,
  LOADING_VERIFY_MOBILE,
  VERIFY_MOBILE_NOT_EXISTS,
  RESET_VERIFY_MOBILE,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  error: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_VERIFY_MOBILE:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: false,
      };

    case VERIFY_MOBILE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: true,
      };
    case VERIFY_MOBILE_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: true,
      };

    case VERIFY_MOBILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        error: false,
        data: action.payload,
      };

    case VERIFY_MOBILE_NOT_EXISTS:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: true,
      };

    case VERIFY_MOBILE_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: true,
      };

    case RESET_VERIFY_MOBILE:
      return (state = initialState);

    default:
      return state;
  }
};
